// extracted by mini-css-extract-plugin
module.exports = {"Container":"View_Container__2cR7u","Header":"View_Header__20HKp","Queries":"View_Queries__2c1sS","Loading":"View_Loading__2hmS8","NoQueries":"View_NoQueries__1Fk6w"};